<template>
<Dialog :header="title" 
v-model:visible="show" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '75vw'}"
:modal="true"
>

<div id="video_player_wrapper">
    <video 
    ref="videoPlayer"
     class="video-js" 
     ></video>
  </div>


<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" 
/>

</template>
</Dialog>

</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css'
export default {

  name: 'VideoPlaybackModal',
  props:["source"],
  data () {
    return {
    	show:false,
    	videoOptions: {
	        autoplay: true,
	        fluid:true,
	        aspectRatio: '32:13',
	        controls: true,
	        sources: [
	          {
	            src:null,
	            type: 'video/mp4'
	          }
	        ]
      },
      player:null,
      title:null,
    }
  },
  computed: {    	
  	apihook()
  	{
  		//return "https://api.verifyhub.io/"
  		let api =  process.env.VUE_APP_API_HOOK
  		api = api.replace("/api/","/")
  		//return api
  		return "https://storage.googleapis.com/verifycloud/"
  	},
   },
  methods:{
  	open(source,title)
  	{
  		
  		let path = source
	  	path =   this.apihook+source
  		this.videoOptions.sources[0].src = path
  		this.show = true
  		setTimeout(()=>{
  			this.title = title
  			this.player = videojs(this.$refs.videoPlayer, this.videoOptions, () => {
		    this.player.log('onPlayerReady', this);
		    });
  		})
  		
	    
  	},
  	close()
  	{
  		this.show = false
  	}
  }
}
</script>

<style lang="css" scoped>
</style>